import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invalid-feedback" }

import { ErrorObject } from "@vuelidate/core";
import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputError',
  props: {
    errors: { default: () => ([]) },
    error: { default: "" }
  },
  setup(__props: any) {


const errorMessage = computed(() => {
  return __props.error || __props.errors.find((e: any) => e)?.$message || __props.error;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("small", null, _toDisplayString(errorMessage.value), 1)
  ]))
}
}

})